import React from 'react'
import './List.css'

const List = props => (
  <div className="List">
    <ul>{props.children}</ul>
  </div>
)

const Li = props => (
  <li className={"List-item " + (props.num ? 'has-number' : '')}>
    {props.num &&
    <span className={"List-number"}>{props.num}</span>
    }

    {props.children}
  </li>
)

export default List
export { Li }